import { makeVar } from '@apollo/client';

const userState = {} as any;
const didState = {} as any;
// 사용자 정보
export const userVar = makeVar(userState);
// did 정보
export const didInfoVar = makeVar(didState);
